import ScalarSidebarSection_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarSection.vue.script.js";
/* empty css                                   */
//#region src/components/ScalarSidebar/ScalarSidebarSection.vue
var ScalarSidebarSection_default = ScalarSidebarSection_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarSection_default as default };

//# sourceMappingURL=ScalarSidebarSection.vue.js.map